import { render, staticRenderFns } from "./SettingsSelectTag.vue?vue&type=template&id=f3804db2&"
import script from "./SettingsSelectTag.vue?vue&type=script&lang=js&"
export * from "./SettingsSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports